











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import Toggle from '@/views/document/section/Toggle.vue';
import Comment from '@/views/document/section/Comment.vue';

@Component({components: {Comment, Toggle}})
export default class Company extends Vue {
  @Prop() readonly group!: any;

  get commentSection(): any {
    return dokument.getItem(16);
  }
}
